import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LazyImage from "../../shared/lazy-image";
import { appUrl } from "../../../constants/url-constants";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import H2Regular from "../../shared/h2-regular/component";
import { FILTER_TYPES } from "../../../utils/filters-v2/constants";
import { useHistory } from "react-router";
import Filters from "../../../utils/filters-v2";
import { DEFAULT_CITY } from "../../../constants/app-constants";
import { getFilterParamsURL, appliedFiltersDataForInlineFilter } from "../../../utils/filters-v2/get-filter-params-url";
import useStyleInjection from "../../../hooks/use-style-injection";
import { AU_FILTER_EVENT, AU_FILTER_EVENTS_KEYS } from "../../../tracking/au.mobile-filter-events";
// import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const ListingFilterSeoRevamp = ({
    title = "",
    allFilters = {},
    filterName = "quotedPrice",
    selectedFilters,
    urlOptions,
    selectedCity,
    itemVisible,
    config,
    updateFilterOptionDataConnect,
    updateSelectedOnScreenFilterConnect,
    updateAppliedFiltersConnect,
    updateAppliedSuggestionsConnect,
    reloadCarListConnect,
    resetCarListConnect,
    updateSelectedSuggestionsConnect,
    showImage,
    suggestions = [],
    replaceSelectedFilterConnect
}) => {
    const history = useHistory();
    const {imageHost} = config || {};
    const {key: filterKey, filterType} = allFilters[filterName] || {};
    const { getOrCreateRef, injectStyles } = useStyleInjection();

    const showFilteredCars = (customFilter, spath) => {
        const filters = new Filters({cityCode: selectedCity.code || DEFAULT_CITY.AU.code});
        reloadCarListConnect(true);
        const {relativeURL} = getFilterParamsURL(customFilter, selectedFilters, spath, filters, urlOptions, allFilters);
        updateSelectedOnScreenFilterConnect("");
        updateAppliedFiltersConnect();
        updateAppliedSuggestionsConnect();
        resetCarListConnect();
        history.replace(relativeURL);
        window.scrollTo(0, 0);
        window.setTimeout(() => {
            window.scrollTo(0, 0);
        });
    };

    const onSelectSuggestion = async (e, suggestion, isSelected) => {
        e.preventDefault();
        // todo:inp fix
        // await yieldToMain();
        const { name: displayText, min, max, spath, subFilterName} = suggestion;

        const cleanup = injectStyles(displayText);

        try {
            // await yieldToMain();

            let data = { filterKey, isSelected, optionKey: displayText, displayText, spath};
            if (subFilterName === "model") {
                data = appliedFiltersDataForInlineFilter(selectedFilters, suggestion, replaceSelectedFilterConnect);
            }
            data = filterType === FILTER_TYPES.RF ? {...data, isRangeFilter: true, rangeValues: { min, max}} : data;

            await Promise.all([
                updateSelectedSuggestionsConnect({...data, isSingleEntity: true, isSuggestion: true}),
                updateFilterOptionDataConnect(data),
                showFilteredCars(data, spath)
            ]);

            // Track event after all operations are complete
            trackDesktopCustomEventsAU(
                AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_FILTER_SUGGESTION,
                {
                    ...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_FILTER_SUGGESTION],
                    eventLabel: `${allFilters[filterName].displayText} - ${suggestion.displayText}`
                }
            );
        } finally {
            // eslint-disable-next-line no-unused-expressions
            cleanup?.();
        }
    };

    const renderChip = (item) => {
        const {name: displayText, spath, image} = item;

        return (
            <a
                ref={getOrCreateRef(displayText)}
                href={`${appUrl()}/${spath}`}
                key={displayText}
                styleName="styles.chip"
                onClick={(e) => onSelectSuggestion(e, item, true)}
            >
                {image && showImage && <LazyImage width="32" height="32" src={imageHost + image} alt={displayText}/>}
                <p>{displayText}</p>
            </a>
        );
    };

    const mapfilter = suggestions.length ? suggestions : [];
    return (
        <section styleName={"styles.sectionWrap"}>
            <div styleName={"styles.wrapper"}>
                <div>
                    <H2Regular text={title}/>
                </div>
                <div styleName="styles.filterSection">
                    {mapfilter.slice(0, (itemVisible || mapfilter.length)).map((item) => renderChip(item))}
                </div>
            </div>
        </section>
    );
};

ListingFilterSeoRevamp.propTypes = {
    selectedOnScreenFilter: PropTypes.string,
    allFilters: PropTypes.object,
    showAllFilters: PropTypes.bool,
    listingCount: PropTypes.number,
    selectedCity: PropTypes.object,
    history: PropTypes.object,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    updateAllFiltersVisibilityConnect: PropTypes.func,
    updateFilterOptionDataConnect: PropTypes.func,
    fetchListingCountConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    selectedFilters: PropTypes.array,
    updateAppliedFiltersConnect: PropTypes.func,
    selectedSuggestions: PropTypes.array,
    updateAppliedSuggestionsConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    updateSortModalVisibilityConnect: PropTypes.func,
    updateUrlOptionsConnect: PropTypes.func,
    totalCars: PropTypes.number,
    urlOptions: PropTypes.object,
    filterName: PropTypes.string,
    updateSelectedSuggestionsConnect: PropTypes.func,
    title: PropTypes.string,
    itemVisible: PropTypes.number,
    config: PropTypes.object,
    showImage: PropTypes.bool,
    suggestions: PropTypes.array,
    replaceSelectedFilterConnect: PropTypes.func
};

export default React.memo(ListingFilterSeoRevamp);
